import * as React from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';

export default function ImageCardKPP({ para }) {
    return (
        <Box
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    
                    maxWidth: {
                        xs: '80vw',
                        sm: '80vw',
                        md: '90vw',
                        lg: '90vw',
                    },
                }}
            >


                <Card
                    sx={{
                        display: 'flex',
                        //minWidth: '75vw',
                        flexDirection:
                        {
                            xs: 'column',
                            sm: 'column',
                            md: 'row',
                            lg: 'row'
                        },
                        width: {
                            xs: '85%',
                            sm: '85%',
                            md: '75%',
                            lg: '75%',
                        },
                        height: '100%',
                    }}
                >
                    


                        <CardMedia
                            sx={{
                                display: 'flex',
                                width: { xs: '99%', sm: '99%', md: '50%', lg: '50%' },
                                minHeight: '99%',
                                position: 'relative',
                                margin: '0.5%',
                                borderRadius: '3px',
                            }}
                            component="img"
                            image={para.pic}
                            //title={para.pde}
                        />
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                display: 'flex',
                                alignContent: 'center',
                                position: 'absolute',
                                margin: '5px',
                                color: 'rgba(255, 255, 255, 0.8)',
                                textShadow: '0 0 8px #000'
                            }}
                        >
                            Valokuvaaja: Amanda Lehtola
                        </Typography>
                    
                    <CardContent
                        sx={{
                            
                            display: 'flex',
                            flexDirection: 'column',
                            
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },

                            /*
                            old 
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },
                            height: { xs: '50%', sm: '50%', md: '100%', lg: '100%' },
                            */
                            padding: 0,
                            margin: 0,
                            p: 0,
                            '&:last-child': { pb: 0 },
                        }}
                    >
                        <Typography
                            gutterBottom variant="h5"
                            component="h2"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                paddingTop: 2,
                                fontSize:
                                {
                                    xs: '6.8vw',
                                    sm: '4.5vw',
                                    md: "2.8vw",
                                    lg: "2.95vw"
                                },
                            }}
                        >
                            {para.hea}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            <a href="https://goo.gl/maps/4qXrP3i6YkZxusJc7" target="_blank" rel="noopener noreferrer">
                            Hyvinkään vanha kirkko</a> sijaitsee aivan Hyvinkään rautatieaseman tuntumassa.
                            Kävelymatka asemalta on 450 metriä. Kirkolta on vihkimisen jälkeen ilmainen 
                            bussikuljetus juhlapaikalle, ilmoitathan halukkuutesi bussikuljetukseen ilmoittautumisen 
                            yhteydessä.
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            Omalla autolla saapuville parkkipaikkoja on kirkon vieressä tien varressa rajoitetusti.
                            Lisätilaa löytyy McDonaldsin vierestä S-marketin pysäköintitalosta,
                            johon parhaiten löytää perille asettamalla Google Mapsiin osoitteeksi <a 
                            href="https://goo.gl/maps/segzKqGr5yt1L7Kh8" target="_blank" rel="noopener noreferrer">
                            Hyvinkään McDonaldsin</a>. Pysäköinti on maksutonta tunnin ajan.
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            {para.tex3}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            Paluukuljetus tapahtuu omakustanteisesti. Matka tilataksilla juhlapaikalta <a 
                            href="https://goo.gl/maps/tXSqYdQgkWUf4VUu8" target="_blank" rel="noopener noreferrer">Hyvinkään 
                            rautatieasemalle</a> kustantaa 38 euroa 5-8 hengelle tämänhetkisellä (28.3.) hinnastolla.
                        </Typography>
                        
                    </CardContent>
                </Card>
            </Box>

        </Box>





    );
}
